import React, { useState } from "react";
import { ReactComponent as PrevIcon } from "assets/common/pagination/prevIcon.svg";
import { ReactComponent as NextIcon } from "assets/common/pagination/nextIcon.svg";
import { cls } from "shared/lib/util/classnames";

interface Props {
  listLength?: number;
  pageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  onChange?: () => void;
}

export function PrimayPagination({
  onChange = () => {},
  listLength = 1,
  pageNumber,
  setPageNumber,
}: Props) {
  const [pageListNum, setPageListNum] = useState<number>(0);
  const division = (array: number[], n: number) => {
    const length = array.length;
    const divide =
      Math.floor(length / n) + (Math.floor(length % n) > 0 ? 1 : 0);
    let newArray = [];

    for (let i = 0; i <= divide; i++) {
      newArray.push(array.splice(0, n));
    }
    newArray = newArray.filter((item) => item.length !== 0);

    return newArray;
  };

  const pageList = division(
    [...Array(listLength)]?.map((_, i: number) => i + 1),
    5,
  );

  const handlePrevBtn = () => {
    onChange();
    setPageNumber(pageList[pageListNum - 1][4]);
    setPageListNum(pageListNum - 1);
  };

  const handlePageBtn = (num: number) => {
    onChange();
    setPageNumber(num);
  };

  const handleNextBtn = () => {
    onChange();
    setPageNumber(pageList[pageListNum + 1][0]);
    setPageListNum(pageListNum + 1);
  };

  return (
    <div className="flex h-[32px] items-center justify-center">
      <div
        className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[3px_0_0_3px] border-[1px] border-r-[0] border-gray-1"
        onClick={pageListNum === 0 ? () => {} : handlePrevBtn}
      >
        <PrevIcon
          className={cls(
            pageListNum === 0
              ? "[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-[#d9d9d9]"
              : "[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-gray-5",
          )}
        />
      </div>
      {pageList[pageListNum]?.map((num, idx: number) => (
        <div
          key={idx}
          className={cls(
            "flex h-[32px] w-[32px] cursor-pointer items-center justify-center border-[1px] border-r-[0] border-gray-1 text-M1",
            pageNumber === num ? "bg-[#e8edff] text-[#1271ff]" : "text-black",
          )}
          onClick={() => handlePageBtn(num)}
        >
          {num}
        </div>
      ))}
      <div
        className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[0_3px_3px_0] border-[1px] border-gray-1"
        onClick={
          listLength === 0 || pageListNum + 1 === pageList.length
            ? () => {}
            : handleNextBtn
        }
      >
        <NextIcon
          className={cls(
            "cursor-pointer",
            listLength === 0 || pageListNum + 1 === pageList.length
              ? "[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-[#d9d9d9]"
              : "[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-gray-5",
          )}
        />
      </div>
    </div>
  );
}
